// @flow
import { put, takeEvery } from 'redux-saga/effects';
import {
    GET_FLIGHTS,
    GET_PRODUCTS,
    DELETE_FLIGHT,
    EDIT_FLIGHT,
    ADD_FLIGHT,
    START_FLIGHT,
    FINISH_FLIGHT,
    GET_TIME_ZONES,
} from './../types/flightManager';

import {
    getFlightsFail,
    getFlightsSuccess,
    deleteFlightFail,
    deleteFlightSuccess,
    editFlightFail,
    editFlightSuccess,
    addFlightFail,
    addFlightSuccess,
    startFlightFail,
    startFlightSuccess,
    finishFlightFail,
    finishFlightSuccess,
    getProductsFail,
    getProductsSuccess,
    getTimeZonesFail,
    getTimeZonesSuccess,
} from '../actions/flightManager';

type Row = {
    id: string,
}
type Action = {
    axiosInstance: Object,
    id: number,
    editedRowData: Row
}
type Flight = {
    id: number,
    beginDateTime: Date,
    endDateTime: Date,
    description: string,
    faults: any,
    flightStatus: any,
    movies: any,
    photos: any,
    points: any
}
type Flights = {
    data: Array<Flight>
};

export function* getFlights(action: Action): Generator<any, void, any> {
    try {
        const { axiosInstance }: Action = action;
        const url: string = 'projects';
        const { data }: Flights = yield axiosInstance.get(url);
        yield put(getFlightsSuccess(data));
    }
    catch (error) {
        yield put(getFlightsFail(error));
    }
}

export function* watchGetFlights(): Generator<any, void, any> {
    yield takeEvery(GET_FLIGHTS, getFlights);
}

export function* deleteFlight(action: Action): Generator<any, void, any> {
    try {
        const { axiosInstance }: Action = action;
        yield axiosInstance.request(
            {
                url: `projects/${action.id}`,
                method: 'delete',
                headers: {
                    'Content-Type': 'application/json',
                }
            }
        );
        yield put(deleteFlightSuccess(action.id));
    }
    catch (error) {
        yield put(deleteFlightFail(error));
    }
}
export function* watchDeleteFlight(): Generator<any, void, any> {
    yield takeEvery(DELETE_FLIGHT, deleteFlight);
}

export function* editFlight(action: Action): Generator<any, void, any> {
    try {
        const { axiosInstance, editedRowData }: Action = action;
        const url: string = `projects/${editedRowData.id}`
        yield axiosInstance.put(url, editedRowData);
        yield put(editFlightSuccess(editedRowData));
    }
    catch (error) {
        yield put(editFlightFail(error));
    }
}
export function* watchEditFlight(): Generator<any, void, any> {
    yield takeEvery(EDIT_FLIGHT, editFlight);
}

export function* addFlight(action: Action): Generator<any, void, any> {
    try {
        const { axiosInstance, editedRowData }: Action = action;
        const url: string = "projects";
        const {data} = yield axiosInstance.post(url, editedRowData)
        yield put(addFlightSuccess(data));
    }
    catch (error) {
        yield put(addFlightFail(error));
    }
}
export function* watchAddFlight(): Generator<any, void, any> {
    yield takeEvery(ADD_FLIGHT, addFlight);
}

export function* startFlight(action: Action): Generator<any, void, any>{
    try{
        const {axiosInstance, id}: Action = action;
        const url: string = `projects/${id}/start`;
        yield axiosInstance.put(url)
        yield put(startFlightSuccess(id));
    }
    catch(error){
        yield put(startFlightFail(error));
    }
}
export function* watchStartFlight(): Generator<any, void, any>{
    yield takeEvery(START_FLIGHT, startFlight);
}

export function* finishFlight(action: Action): Generator<any, void, any>{
    try{
        const {axiosInstance, id}: Action = action;
        const url: string = `projects/${id}/finish`;
        yield axiosInstance.put(url)
        yield put(finishFlightSuccess(id));
    }
    catch(error){
        yield put(finishFlightFail(error));
    }
}
export function* watchfinishFlight(): Generator<any, void, any>{
    yield takeEvery(FINISH_FLIGHT, finishFlight);
}

export function* getProducts(action: Action): Generator<any, void, any> {
    try {
        const { axiosInstance }: Action = action;
        const url: string = 'products';
        const { data }: Flights = yield axiosInstance.get(url);
        yield put(getProductsSuccess(data));
    }
    catch (error) {
        yield put(getProductsFail(error));
    }
}

export function* watchGetProducts(): Generator<any, void, any> {
    yield takeEvery(GET_PRODUCTS, getProducts);
}

export function* getTimeZones(action: Action): Generator<any, void, any> {
    try {
        const { axiosInstance }: Action = action;
        const url: string = 'projects/timezones';
        const { data }: Flights = yield axiosInstance.get(url);
        yield put(getTimeZonesSuccess(data));
    }
    catch (error) {
        yield put(getTimeZonesFail(error));
    }
}

export function* watchGetTimeZones(): Generator<any, void, any> {
    yield takeEvery(GET_TIME_ZONES, getTimeZones);
}


// WEBPACK FOOTER //
// ./src/sagas/flightManager.jsx